import './CookiesPopUp.scss';
import React from 'react';


function CookiesPopUp(props) {

  return (
    <div className="cookies-wrapper">
        <div className="cookies-content">
            <div className="cookies-text">
                {props.t("cookie_text")}
            </div>
            <div className="cookies-buttons-wrapper">
                <div className="button-cookies-accept">
                    <button onClick={props.onClickPopUpAgreeButton}>{props.t("cookie_confirm")}</button>
                </div>
                <div className="button-cookies-deny">
                    <button onClick={props.onClickPopUpDenyButton}>{props.t("cookie_deny")}</button>
                </div>
            </div>
        </div>
    </div>
  );
}

export default CookiesPopUp;